<template>
  <v-container>
    <h2 class="text-center blue-text">sorry, this promotion is not open yet</h2>
    <p class="text-center white-text">Visit us again from the 10th October for a chance to win one of 1,000 McCain Mitts, plus, there's a chance to win a festive family trip to Lapland!*</p>
    <v-img
      :src="packShot"
      contain
      class="packshot-footer small-margin"
    ></v-img>   
  </v-container>
</template>

<script>
export default {
  data: () => ({
    packShot : {src:require('../assets/Packshots.png')}
  }),
};
</script>
